export default __webpack_public_path__ + "static/media/ic_lifestore.d074c6b5.png";